import { NgModule } from '@angular/core';

import { BankInstitutionsModule } from './bankinstitutions/bankinstitutions.module'
import { PaymentsModule } from './payments/payments.module';
import { BankStatementsBatchModule } from './bank-statements-batch/bank-statements-batch.module';
import { PendingTransactionsOverviewModule } from './pending-transactions-overview/pending-transactions-overview.module';

import { FinanceService } from './finance.service';
import {BankStatementController} from '../entities/finance/bank-statement/bank-statement.controller';

@NgModule({
    imports: [
        BankInstitutionsModule,
        PaymentsModule,
        BankStatementsBatchModule,
        PendingTransactionsOverviewModule
    ],
    providers: [FinanceService, BankStatementController],
})

/**
 * Main module for the Finance modules.
*/
export class FinanceModule { }



// WEBPACK FOOTER //
// ./src/app/finance/finance.module.ts